import React, { useState } from 'react';
import './ExerciseSteps.css';

const QuestionStep = ({ step, onContinue }) => {
  const [answer, setAnswer] = useState('');

  const handleContinue = () => {
    if (answer.trim()) {
      onContinue(answer);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && answer.trim()) {
      handleContinue();
    }
  };

  return (
    <div className="step-container">
      <div className="step-content">
        <h2 className="step-title">{step.title}</h2>
        <div className="step-text">
          {step.content}
        </div>
        <div className="input-container">
          <textarea
            className="question-input"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder={step.placeholder || 'Escribe tu respuesta aquí...'}
            rows={4}
          />
        </div>
      </div>
      <div className="step-actions">
        <button 
          className={`step-button ${answer.trim() ? 'primary' : 'disabled'}`}
          onClick={handleContinue}
          disabled={!answer.trim()}
        >
          Continuar
        </button>
      </div>
    </div>
  );
};

export default QuestionStep; 